// extracted by mini-css-extract-plugin
export var base = "icon-module--base--7d6b9";
export var l = "icon-module--l--5c1b4";
export var m = "icon-module--m--e5364";
export var s = "icon-module--s--0d194";
export var socials = "icon-module--socials--177dd";
export var xl = "icon-module--xl--49c32";
export var xxl = "icon-module--xxl--47fb1";
export var xxxl = "icon-module--xxxl--7f4f6";